<template>
    <div class="animated fadeIn">
        <b-row>
            <b-col lg="12">
                <b-card>
                    <div slot="header">
                        <strong>{{ editing ? 'Sửa' : 'Xem chi tiết' }} dự án</strong>
                    </div>
                    <b-form @submit.prevent="save" v-if="project.id">
                        <b-row>
                            <b-col md="6">
                                <b-form-group label="Phần mềm đồng bộ:"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <label class="col-form-label">{{ $store.getters.getSyncSourceType(project.syncSourceType) }}</label>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col md="6">
                                <b-form-group label="Đơn vị quản lý: "
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              :label-class="editing? 'required' : ''"
                                              label-align="left">
                                    <b-form-input type="text" style="display: none"
                                                  v-model="$v.project.unitId.$model"
                                                  :state="$v.project.unitId.$dirty? !$v.project.unitId.$error : null">
                                    </b-form-input>
                                    <unit-tree v-model="project.unitId" ref="unitTree" v-if="editing"></unit-tree>
                                    <b-form-invalid-feedback id="nameFeedback">
                                        Vui lòng nhập đơn vị quản lý
                                    </b-form-invalid-feedback>
                                    <label class="col-form-label" v-if="!editing">{{ project.unitName }}</label>
                                </b-form-group>
                                <b-form-group label="Mã dự án: "
                                              label-for="input-code"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              :label-class="editing? 'required' : ''"
                                              label-align="left">
                                    <b-form-input type="text" id="input-code" v-if="editing"
                                                  aria-describedby="codeFeedback"
                                                  v-model="$v.project.code.$model"
                                                  :state="($v.project.code.$dirty? !$v.project.code.$error : null) && ($v.codeUnique.$dirty? !$v.codeUnique.$error : null)">
                                    </b-form-input>
                                    <b-form-invalid-feedback id="codeFeedback" v-if="$v.project.code.$error">
                                        Vui lòng nhập mã
                                    </b-form-invalid-feedback>
                                    <b-form-invalid-feedback id="existingCodeFeedback" v-if="!$v.project.code.$error && ($v.codeUnique.$error)">
                                        Mã dự án đã tồn tại
                                    </b-form-invalid-feedback>
                                    <label class="col-form-label" v-if="!editing">{{ project.code }}</label>
                                </b-form-group>
                                <b-form-group label="Tên dự án: "
                                              label-for="input-name"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              :label-class="editing? 'required' : ''"
                                              label-align="left">
                                    <b-form-input type="text" id="input-name" v-if="editing"
                                                  aria-describedby="nameFeedback"
                                                  v-model="$v.project.name.$model"
                                                  :state="$v.project.name.$dirty? !$v.project.name.$error : null">
                                    </b-form-input>
                                    <b-form-invalid-feedback id="nameFeedback">
                                        Vui lòng nhập tên
                                    </b-form-invalid-feedback>
                                    <label class="col-form-label" v-if="!editing">{{ project.name }}</label>
                                </b-form-group>
                                <b-form-group label="Ghi chú: "
                                              label-for="input-code"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <b-form-textarea v-model="project.description" v-if="editing"
                                                     placeholder="Nhập ghi chú..."
                                                     rows="5"
                                                     max-rows="5"></b-form-textarea>
                                    <label class="col-form-label" v-if="!editing">{{ project.description }}</label>
                                </b-form-group>
                                <b-form-group label="Số quyết định: "
                                              label-for="input-name"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <b-form-input type="text" id="input-name" v-if="editing"
                                                  v-model="project.decisionNumber">
                                    </b-form-input>
                                    <label class="col-form-label" v-if="!editing">{{ project.decisionNumber }}</label>
                                </b-form-group>
                            </b-col>
                            <b-col md="6">
                                <b-form-group label="Tổng kinh phí: "
                                              label-for="input-code"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <b-input-group size="md" append="₫" v-if="editing">
                                        <b-form-input type="number" min="0" step="1000" v-model="projectExpense" readonly></b-form-input>
                                    </b-input-group>
                                    <label class="col-form-label" v-if="!editing">{{ projectExpense | currency }}</label>
                                </b-form-group>
                                <b-form-group label="Nguồn NSNN: "
                                              label-for="input-code"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <b-input-group size="md" append="₫" v-if="editing">
                                        <b-form-input type="number" min="0" v-model="project.expenseStateBudget"></b-form-input>
                                    </b-input-group>
                                    <label class="col-form-label" v-if="!editing">{{ project.expenseStateBudget | currency }}</label>
                                </b-form-group>
                                <b-form-group label="Nguồn ODA: "
                                              label-for="input-code"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <b-input-group size="md" append="₫" v-if="editing">
                                        <b-form-input type="number" min="0" v-model="project.expenseOda"></b-form-input>
                                    </b-input-group>
                                    <label class="col-form-label" v-if="!editing">{{ project.expenseOda | currency }}</label>
                                </b-form-group>
                                <b-form-group label="Nguồn viện trợ: "
                                              label-for="input-code"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <b-input-group size="md" append="₫" v-if="editing">
                                        <b-form-input type="number" min="0" v-model="project.expenseAid"></b-form-input>
                                    </b-input-group>
                                    <label class="col-form-label" v-if="!editing">{{ project.expenseAid | currency }}</label>
                                </b-form-group>
                                <b-form-group label="Nguồn khác: "
                                              label-for="input-code"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <b-input-group size="md" append="₫" v-if="editing">
                                        <b-form-input type="number" min="0" v-model="project.expenseOther"></b-form-input>
                                    </b-input-group>
                                    <label class="col-form-label" v-if="!editing">{{ project.expenseOther | currency }}</label>
                                </b-form-group>
                                <b-form-group label="Ngày bắt đầu: "
                                              label-for="input-name"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <date-picker v-model="project.startDate" placeholder="dd/mm/yyyy" style="width:100%" v-if="editing"></date-picker>
                                    <label class="col-form-label" v-if="!editing">{{ project.startDate | formatDate }}</label>
                                </b-form-group>
                                <b-form-group label="Ngày kết thúc: "
                                              label-for="input-code"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <b-form-input type="text" style="display: none"
                                                  aria-describedby="parentIdFeedback"
                                                  v-model="$v.project.endDate.$model"
                                                  :state="$v.project.endDate.$model && $v.project.endDate.$dirty ? !$v.project.endDate.$error : null"></b-form-input>
                                    <date-picker v-model="project.endDate" v-if="editing" placeholder="dd/mm/yyyy" style="width:100%"></date-picker>
                                    <b-form-invalid-feedback>
                                        Ngày kết thúc không được nhỏ hơn ngày bắt đầu
                                    </b-form-invalid-feedback>
                                    <label class="col-form-label" v-if="!editing">{{ project.endDate | formatDate }}</label>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col md="6">
                                <b-form-group label="Chủ đầu tư: "
                                              label-for="input-name"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <b-form-input type="text" id="input-name" v-if="editing"
                                                  v-model="project.investor">
                                    </b-form-input>
                                    <label class="col-form-label" v-if="!editing">{{ project.investor }}</label>
                                </b-form-group>
                            </b-col>
                            <b-col md="6">
                                <b-form-group label="Địa điểm: "
                                              label-for="input-name"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <b-form-input type="text" id="input-name" v-if="editing"
                                                  v-model="project.location">
                                    </b-form-input>
                                    <label class="col-form-label" v-if="!editing">{{ project.location }}</label>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <!--<b-row>
                            <b-col md="6">
                                <b-form-group label="Ghi chú: "
                                              label-for="input-name"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <b-form-textarea v-model="project.notes" v-if="editing"
                                                     placeholder="Nhập mô tả..."
                                                     rows="5"
                                                     max-rows="5"></b-form-textarea>
                                    <label class="col-form-label" v-if="!editing">{{ project.notes }}</label>
                                </b-form-group>
                            </b-col>
                        </b-row>-->
                        <b-row>
                            <b-col>
                                <b-form-group label="" :label-cols="4">
                                    <!--<b-button type="button" variant="primary" @click="edit" v-show="!editing">Sửa</b-button>-->
                                    <b-button type="submit" variant="primary" v-if="editing">Lưu</b-button>
                                    <b-button type="button" variant="secondary" :to="{ path: '../' }">Quay lại</b-button>
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </b-form>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>
<script>
    import { mapState } from 'vuex'
    import { validationMixin } from 'vuelidate'
    import { mixins } from '@/shared/mixins'
    import { required } from 'vuelidate/lib/validators'

    export default {
        name: 'ProjectDetail',
        mixins: [validationMixin, mixins],
        data() {
            return {
                codeUnique: 'ok',
                project: {},
                editing: this.$route.meta.editing
            }
        },
        computed: {
            projectId() {
                return this.$route.params.projectId;
            },
            projectExpense() {
                return (parseInt(this.project.expenseStateBudget) || 0) + (parseInt(this.project.expenseOda) || 0) + (parseInt(this.project.expenseAid) || 0) + (parseInt(this.project.expenseOther) || 0);
            },
            ...mapState({
                units: (state, getters) => getters.unitTree,
            })
        },
        validations: {
            project: {
                code: { required },
                name: { required },
                unitId: { required },
                endDate: { greaterThanStartDate: (value, vm) => !value || !vm.startDate || value >= vm.startDate }
            },
            codeUnique: { required }
        },
        created() {
            this.loadProjectDetail();
        },
        methods: {
            loadProjectDetail() {
                var vm = this;
                return this.$services.get(`master-data/projects/${this.projectId}`).done(project => {
                    vm.project = project;
                });
            },
            edit() {
                this.editing = true;
            },
            back() {
                this.$router.push({ path: '../' });
            },
            save() {
                this.$v.$touch();
                var vm = this;
                if (vm.project.code != null && vm.project.code != '') {
                    vm.$services.get(`master-data/existing-projects-code`, { id: vm.project.id || '', code: vm.project.code || '' }).done(returnData => {
                        if (!returnData) {
                            vm.codeUnique = "required";
                            if (!vm.$v.$invalid) {
                                vm.$services.put(`master-data/projects/${vm.projectId}`, vm.project).done(() => {
                                    vm.$toastr.s('Cập nhật dự án thành công');
                                    vm.back();
                                });
                            }
                        }
                        else {
                            vm.codeUnique = "";
                        }
                    });
                }

            },
        }
    }
</script>
<style scoped>
</style>
